import logoImg from '../assets/images/logo/logo.png';
import Comp_Popup_Contact from '../component_version2/comp_popup_contact';
import './footer.css';
export const Footer=()=>{

    return(
        <div>
            {/* <Comp_Popup_Contact/> */}
        <div className="footer-area">
        <div className="footer-container">
            <div className="footer-top">
                <div className="container">
                    <div className="row">
                        
                        <div className="col-md-12 col-lg-3 mb-md-30px mb11-lm-30px">
                            <div className="single-wedge">
                            <img style={{"background":"#fff"}} src={logoImg} class="company-logo"/>
                            
                            </div>
                        </div>
                        <div className="col-md-12 col-lg-4 mb-lm-30px">
                            <div className="single-wedge">
                                <h4 className="footer-herading">Contact Details</h4>
                                <div className="footer-links">
                                    <div className="footer-row">
                                    <p>Gmail : citymontessori786@gmail.com<br/>
Landline : 0734-3562968<br/>
Phone No : 70005-96022 <br/>

</p>
<div class="social-icons">
<a target="blank"  href="https://www.youtube.com/@citymontessori2003"><i class="fa fa-youtube" aria-hidden="true"></i></a>
<a target="blank" href="https://www.instagram.com/citymontessori_kindergarten/"><i class="fa fa-instagram" aria-hidden="true"></i></a>
                    <a target="blank" href="https://www.facebook.com/people/City-Kinder-Garten/100057544844057/"><i class="fa fa-facebook" aria-hidden="true"></i></a>
                    
                </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                       
                        <div className="col-md-6 col-sm-6 pl-10 col-lg-3 mb-md-30px mb12-lm-30px">
                            <div className="single-wedge">
                                <h4 className="footer-herading">Quick Links</h4>
                                <div className="footer-links">
                                    <div className="footer-row">
                                        <ul className="align-items-center">
                                            <li className="li"><a className="single-link" href="../home">Home</a></li>
                                            <li className="li"><a className="single-link" href="../about_us">About Us</a></li>
                                       
                                            <li className="li"><a className="single-link" href="../academic">Academic</a></li>
                                            <li className="li"><a className="single-link" href="../admission">Admission</a></li>
                                            {/* <li className="li"><a className="single-link" href="../specialties">Our Specialities</a></li> */}
                                            <li className="li"><a className="single-link" href="../gallery">gallery</a></li>
                                            <li className="li"><a className="single-link" href="../contact_us">Contact Us</a></li>
                                            
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                        <div className="col-md-6 col-lg-2 col-sm-6 mb12-lm-30px">
                            <div className="single-wedge">
                                <h4 className="footer-herading">Information</h4>
                                <div className="footer-links">
                                    <div className="footer-row">
                                        <ul className="align-items-center">
                                        <li className="li"><a className="single-link" href="../about_school">About School</a></li>
                                            <li className="li"><a className="single-link" href="../school_activities">School Activities</a></li>
                                            <li className="li"><a className="single-link" href="../courses">Courses</a></li>
                                            <li className="li"><a className="single-link" href="../extra_curriculam">Extra Curriculam</a></li>
                                            <li className="li"><a className="single-link" href="../authorization">Authorization</a></li>
                                            <li className="li"><a className="single-link" href="../privacy_policy">Privacy Policy</a>
                                            </li>
                                            <li className="li"><a className="single-link" target='blank'  href="https://www.mpbse.nic.in/">MP-Board</a></li>
                                            {/* <li className="li"><a className="single-link" href="../privacy_policy">Privacy Policy</a></li>
                                            <li className="li"><a className="single-link" href="../cookie_policy">Cookie Policy</a></li>
                                             */}
                                            
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                        
                       
                      
                        
                    </div>
                </div>
            </div>
            <div className="footer-bottom">
                <div className="container">
                    <div className="row flex-sm-row-reverse">
                        {/* <div className="col-md-6 text-right">
                            <div className="payment-link">
                                <img src="assets/images/icons/payment.png" alt="" />
                            </div>
                        </div> */}
                        <div className="col-md-12 text-left">
                            <p className="copy-text">© Copyright 2025 <strong>City Montessori High School</strong> <a className="company-name" href="#">
                                {/* <strong>ashtechnologies.in</strong> */}
                                </a>.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        </div>
        {/* <Cart_Canvas/> */}
        <div className="offcanvas-overlay"></div>
        </div>)
}
export default Footer;